export default "__VITE_ASSET__DayhjqBR__"